<template>
  <GlobalWindow
      :title="title"
      width="calc(100% - 250px)"
      :visible.sync="visible"
      :confirm-working="isWorking"
      @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="标题" prop="title">
        <el-input v-model="form.title" placeholder="请输入标题" v-trim/>
      </el-form-item>
      <el-form-item label="所属模块" v-if="form.type == 0" prop="module">
        <el-select v-model="form.module" >
          <el-option :value="0" label="行业资讯"/>
          <el-option :value="1" label="运营经验"/>
          <el-option :value="2" label="功能介绍"/>
          <el-option :value="3" label="市场信息"/>index
        </el-select>
      </el-form-item>
      <el-form-item label="列表图" prop="imgurl" >
        <div class="upload_wrap">
          <UploadAvatarImage :file="{ 'imgurlfull': form.fullImgurl, 'imgurl': form.imgurl }" :uploadData="{folder:''}"   @uploadSuccess="uploadAvatarSuccess"   />
        </div>
      </el-form-item>
      <el-form-item label="简介" prop="detail">
        <el-input  type="textarea"   :rows="10"  v-model="form.detail" placeholder="请输入简介" v-trim/>
      </el-form-item>
      <el-form-item label="发布日期" prop="releaseDate" >
        <el-date-picker v-model="form.releaseDate" value-format="yyyy-MM-dd HH:mm:ss" type="datetime">  </el-date-picker>
      </el-form-item>
      <el-form-item label="内容" prop="content"   >
        <RichEditor     :richData="form.content" :styleEditor="styleEditor"  @getWangedditor="getWangedditor" :readonly="false"/>
        <!--        <RichEditor     :richData="form.content" :styleEditor="styleEditor"  @getWangedditor="getWangedditor" :readonly="false"/>-->
      </el-form-item>
      <el-form-item label="状态" prop="status" required class="form-item-status">
        <el-switch v-model="form.status" :active-value="0" :inactive-value="1" active-color="#13ce66"/>
      </el-form-item>
      <el-form-item label="排序码（降序）" prop="sortnum">
        <el-input v-model="form.sortnum" placeholder="请输入排序码" v-trim/>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="form.remark" type="textarea" placeholder="请输入备注" v-trim/>
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>
<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
import UploadAvatarImage from '@/components/common/UploadAvatarImage'
import RichEditor from '@/components/common/RichEditor'
import '@wangeditor/editor/dist/css/style.css'
import dayjs from 'dayjs';
export default {
  name: 'OperaInformationWindow',
  extends: BaseOpera,
  components: { GlobalWindow, UploadAvatarImage, RichEditor },
  data () {
    return {
      // 表单数据
      styleEditor: 'border: 1px solid #ccc;display: inline-block;height:800px;min-height :500px;',
      form: {
        id: null,
        remark: '',
        title: '',
        type:null,
        detail: '',
        imgurl: '',
        module: 0,
        fullImgurl: '',
        jumpType: 0,
        content: '',
        releaseDate: new Date(),
        sortnum: '',
        status: 0
      },
      // 验证规则
      rules: {
        title: [
          { required: true, message: '请输入标题' }
        ]
      }
    }
  },
  created () {
    this.config({
      api: '/business/information',
      'field.id': 'id'
    })
  },
  methods: {
    open (title, target,type) {
      this.title = title
      this.visible = true
      // 新建
      if (target == null) {
        this.$nextTick(() => {
          this.$refs.form.resetFields()
          this.form= {
            id: null,
            remark: '',
            title: '',
            type:type,
            detail: '',
            releaseDate: dayjs().format('YYYY-MM-DD HH:mm:ss'),
            imgurl: '',
            fullImgurl: '',
            jumpType: 0,
            content: '',
            module: 0,
            sortnum: '',
            status: 0
          }
        })
        return
      }
      // 编辑
      this.$nextTick(() => {
        for (const key in this.form) {
          this.form[key] = target[key]
        }
        console.log(111+this.form.content)
      })
    },
    // 上传图片
    getWangedditor (val) {
      this.form.content = val
    },
    uploadAvatarSuccess (file) {
      this.form.imgurl = file.imgurl
      this.form.fullImgurl = file.imgurlfull
    }
  }
}
</script>
<style>
::v-deep .w-e-text-container {
  height: 420px !important;
}
.w-e-text-container .w-e-scroll {
  height: 500px !important;
  -webkit-overflow-scrolling: touch;
}
</style>
